<script setup lang="ts">
import {defineProps} from "vue"

const props = defineProps<{
    label: string
}>()

</script>

<template>
    <span class="group-hover:opacity-100 transition-opacity bg-mono-ns-200 px-6 py-1 text-p6 rounded-lg absolute left-1/2 -translate-x-1/2 -translate-y-10 opacity-0 mx-auto whitespace-nowrap">
        {{props.label}}
        <span class="absolute -bottom-1 left-1/2 -z-10 h-3 w-3 -translate-x-1/2 rotate-45 bg-mono-ns-200"></span>
    </span>
</template>

<style scoped>

</style>
